import { render, staticRenderFns } from "./SupportContact.vue?vue&type=template&id=3acbe95b&scoped=true"
import script from "./SupportContact.vue?vue&type=script&lang=js"
export * from "./SupportContact.vue?vue&type=script&lang=js"
import style0 from "./SupportContact.vue?vue&type=style&index=0&id=3acbe95b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acbe95b",
  null
  
)

export default component.exports